<template lang='pug'>
  include /mixins
  +b.modal-wrapper
    +e.close(@click='$emit("close")') 
      icon(type='close')
    validation-observer(
      ref='observer'
      tag='form'
      v-slot='{invalid}'
      @submit.prevent='send'
      novalidate
      autocomplete='off'
    )
      row(offset)
        cell(cols='12')
          v-caption(
            :variant='["bold"]'
            size='8'
          ) {{ _('Auto report recipients') }}
        cell(cols='12')
          row(offset)
            template(v-for='(cell, index) in emails' v-if='emails.length')
              cell(cols :key='index' )
                +b.variant-checker
                  +e.title.P  {{ cell.email }}
                    strong(v-if='cell.frequency') ({{ cell.frequency.value || cell.frequency }})
                  +e.close(@click='removeEmail(index)')
                    icon(type='close')
            cell(cols='12' v-else)
              v-caption(
                size='6'
              ) {{ emails.join(', ') || _('No recipients added yet') }}
      row(offset)
        cell(cols='9')
          ui-input(
            :placeholder="_('New email')"
            :val='email'
            type='search'
            name='title'
            size='lg'
            bg='relief-3'
            border='whole'
            v-model='email'
            @input='validateEmail(email)'
          )
        cell(cols='3')
          v-button(
            variant='accent',
            @click.prevent='addEmail'
          )
            v-button-element(size='lg') 
              v-caption(
                :variant='["bold", "uppercase"]' 
                size='6'
              ) {{ _('Add') }}
        cell(cols='12' v-if='emailError')
          v-caption(
            :variant='["bold", "warning"]' 
            size='6'
          ) {{ _('Email is invalid') }}

        cell(cols='12')
          v-select(
            v-model='tours'
            :val='tours'
            :full='true'
            :placeholder="_('Tour email')"
            :options='toursChoices'
            :name='"type"'
            label-by="email"
            track-by="email"
            :multiple='true'
            size='lg'
            bg='relief-3'
            border='whole'
          )             
        cell(cols='12')
          v-select(
            v-model='frequency'
            :val='frequency'
            :full='true'
            :placeholder="_('Generation frequency')"
            :options='choices'
            :name='"type"'
            label-by="value"
            track-by="value"
            size='lg'
            bg='relief-3'
            border='whole'
          )            
        cell(cols='narrow 12-xl' justification='right')
          v-button(
            variant='success'
            type='submit'
          )
            v-button-element(size='lg') 
              v-caption(
                :variant='["bold", "uppercase"]' 
                size='6'
              ) {{ _('SAVE') }}
          
</template>

<script>

import Api from '@cabinet/services/api/events'
import { successHandler, errorHandler } from '@cabinet/util'

const EMAILREG = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
  props: {
    show: {
      required: true
    },
  },
  data() {
    return {
      emails: [],
      choices: [
        { text: this._('Daily'), value: 'daily' },
        { text: this._('Weekly'), value: 'weekly' },
      ],
      email: '',
      frequency: '',
      tours: [],
      toursChoices: [],
    }
  },
  created() {
    this.getAssignedReportsEmails()
    this.getShowReportsEmails()
  },
  methods: {
    removeEmail(index) {
      this.emails.splice(index, 1)
    },
    async send() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) return
      const items = this.emails.map(item => ({ email: item.email, frequency: item.frequency || this.frequency.value }))
      console.log(items, '>>>>>', this.frequency);
      if (this.tours && this.tours.length) {
        items.push(...this.tours.map(item => ({ email: item.email, frequency: this.frequency.value })))
      }
      const i = items.filter(e => e.frequency)
      Api.setShowReportsEmails(this.show.id, {
        items: i,
      }).then((res) => {
        // this.$toast.success(this._('Settings saved successfully'))
        successHandler({
          meta: {
            title: this._('Auto report settings saved successfully')
          },
          data: {
            status: 'complete'
          }
        }, this)
        this.$emit('close')
      }).catch((err) => {
        let { errors } = err.response.data
        this.isLoad = false
        errorHandler(errors, this)
        // this.$toast.error(this._('An error occurred while saving settings'))
      })
      // this.$refs.observer.reset()
     
    },
    validateEmail(email) {
      this.emailError = false
      if (!EMAILREG.test(this.email)) {
        this.emailError = true
      }
    },
    addEmail() {
      this.validateEmail(this.email)
      if (this.emailError) return
      this.emails.push({ email: this.email, frequency: null })
      this.email = ''
    },
    getShowReportsEmails() {
      Api.getShowReportsEmails(this.show.id).then((res) => {
        console.log(res.data, '==================11112324');
        this.emails = res.data.data
      })
    },
    getAssignedReportsEmails() {
      Api.getEventAssignedReportsEmails(this.show.event).then((res) => {
        console.log(res.data, '==================1111');
        this.toursChoices = res.data.data.map(item => ({ ...item, title: item.email }))
      })
    }
  },
  
}
</script>